export type PasswordStrength = 'weak' | 'medium' | 'strong';

export function getPasswordStrength(password: string): PasswordStrength {
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

  const characterTypes = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length;

  // Check Strong first (most specific condition)
  if (password?.length > 8 && hasLower && hasUpper && hasNumber && hasSpecial) {
    return 'strong';
  }

  // Check Weak conditions (ANY of these makes it weak)
  if (
    password?.length < 6 || // < 6 characters
    characterTypes === 1 || // contains only one type of character
    (!hasUpper && !hasSpecial) // No uppercase letters or special characters
  ) {
    return 'weak';
  }

  // Check Medium conditions - ALL 3 conditions must be true
  if (password?.length >= 6 && characterTypes >= 2 && (hasUpper || hasSpecial)) {
    return 'medium';
  }

  // Default to weak (includes passwords > 10 chars that don't meet strong criteria)
  return 'weak';
}
